.list {
  position: relative;
  background-color: transparent;
  gap: var(--mantine-spacing-lg);
}

.indicator {
  height: 0;
  bottom: 0;
  box-shadow: none;
  border-bottom: 1.5px solid var(--mantine-color-brand-6);
}

.tab {
  background-color: transparent;
  z-index: 1;
  font-weight: 500;
  transition: color 100ms ease;
  padding: 8px 0;

  &[data-active] {
    padding: 8px 0;
    background-color: transparent;
    color: var(--mantine-color-black);
    font-weight: 700;
  }
}

.tabLabel {
  color: var(--mantine-color-gray-8);
  font-size: var(--mantine-font-size-sm);
}

.clientSearchDropdown {
  padding: var(--mantine-spacing-xxxs);
  border-radius: var(--mantine-spacing-xs);
  margin-left: var(--mantine-spacing-md);
}

.clientSearchInput {
  border-color: var(--mantine-color-gray-0);
  border-radius: var(--mantine-spacing-xs);
}

.clientSearchResultButtonLabel {
  justify-content: flex-start;
}

.scrollStrip {
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  min-width: 0;
  flex: 1;
}

.scrollStrip::-webkit-scrollbar {
  display: none;
}

.scrollTab {
  flex-shrink: 0;
  text-wrap: nowrap;
}
